import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from "@mkikets/react-datatable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import RefferalManagerPlan from "../partials/RefferalManagerPlan";
import RefferalManagerShare from "../partials/RefferalManagerShare";
import { toast, ToastContainer } from "react-toastify";
import Moment from "moment";
import $ from "jquery";
import { baseUrl } from "../../actions/baseUrl";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
class RefralManager extends Component {
  constructor(props) {
    super(props);

    this.columns = [
      {
        key: "id",
        text: "#",
        className: "id",
        align: "left",
        sortable: true,
        cell: (row, index) => index + 1,
      },
      {
        key: "name",
        text: "Name",
        className: "name",
        align: "left",
        sortable: true,
      },
      {
        key: "short_name",
        text: "Short Name",
        className: "short_name",
        align: "left",
        sortable: true,
      },
      {
        key: "is_deposit",
        text: "Deposit",
        className: "is_deposit",
        align: "left",
        sortable: true,
        cell: (record) => {
          return (
            <Fragment>
              {record.is_deposit == "1" ? "Enabled" : "Suspended"}
            </Fragment>
          );
        },
      },
      {
        key: "is_withdrawal",
        text: "Withdrawal",
        className: "is_withdrawal",
        align: "left",
        sortable: true,
        cell: (record) => {
          return (
            <Fragment>
              {record.is_withdrawal == "1" ? "Enabled" : "Suspended"}
            </Fragment>
          );
        },
      },
      {
        key: "is_trade",
        text: "Trade",
        className: "is_trade",
        align: "left",
        sortable: true,
        cell: (record) => {
          return (
            <Fragment>
              {record.is_trade == "1" ? "Enabled" : "Suspended"}
            </Fragment>
          );
        },
      },
      {
        key: "order_sequence",
        text: "Sequence",
        className: "order_sequence",
        align: "left",
        sortable: true,
      },
      {
        key: "created",
        text: "Date",
        className: "date",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>{Moment(record.created).format("lll")}</Fragment>;
        },
      },
      {
        key: "action",
        text: "Action",
        className: "action",
        width: 100,
        align: "left",
        sortable: false,
        cell: (record) => {
          return (
            <Fragment>
              <button
                data-toggle="modal"
                data-target="#update-user-modal"
                className="btn btn-primary btn-sm"
                onClick={() => this.editRecord(record)}
                style={{ marginRight: "5px" }}
              >
                <i className="fa fa-edit"></i>
              </button>
              {/* <button
                                className="btn btn-danger btn-sm"
                                onClick={() => this.deleteRecordMgs(record)}>
                                <i className="fa fa-trash"></i>
                            </button> */}
            </Fragment>
          );
        },
      },
    ];

    this.config = {
      page_size: 10,
      length_menu: [10, 20, 50],
      filename: "Crypto Currency List",
      no_data_text: "No record found!",
      button: {
        print: true,
        csv: true,
      },
      language: {
        length_menu: "Show _MENU_ result per page",
        filter: "Filter in records...",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        pagination: {
          first: "First",
          previous: "Previous",
          next: "Next",
          last: "Last",
        },
      },
      show_length_menu: true,
      show_filter: true,
      show_pagination: true,
      show_info: true,
    };

    this.state = {
      records: [],
      cryptoCheckedBoxes: [],
      currentRecord: {
        id: "",
        name: "",
        short_name: "",
        order_sequence: "",
        available_for_loan: "",
        available_for_p2p: "",
        icon: "",
      },
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    if (
      this.props.auth.user.cryptoCurrency !== undefined &&
      this.props.auth.user.cryptoCurrency !== 1
    ) {
      this.props.history.push("/dashboard");
    }
    this.getData();
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.auth.user.cryptoCurrency !== undefined &&
      this.props.auth.user.cryptoCurrency !== 1
    ) {
      this.props.history.push("/dashboard");
    }
    if (
      nextProps.cryptodata !== undefined &&
      nextProps.cryptodata.crypto !== undefined &&
      nextProps.cryptodata.crypto.data !== undefined &&
      nextProps.cryptodata.crypto.data.message !== undefined
    ) {
      $("#update-user-modal").modal("hide");
      $("#add-user-modal").modal("hide");
      toast(nextProps.cryptodata.crypto.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
      this.setState({ errors: { currencyImage: "" } });
    }
    this.getData();
  }

  getData = () => {
    axios
      .get(baseUrl + "/api/refreal-data")
      .then((res) => {
        if (res.status === 200) {
          console.log("res", res.data);
          this.setState({
            monthly: res.data[0].monthly,
            quartly: res.data[0].quarterly,
            half_yearly: res.data[0].half_yearly,
            yearly: res.data[0].yearly,
          });
        }
      })
      .catch();
  };
  editRecord = (record) => {
    this.setState({
      currentRecord: {
        id: record.id,
        name: record.name,
        short_name: record.short_name,
        chain: record.chain_type,
        url: record.coin_tron,
        order_sequence: record.order_sequence,
        icon: record.icon,
        is_deposit: record.is_deposit,
        is_withdrawal: record.is_withdrawal,
        is_trade: record.is_trade,
      },
    });
  };

  toggleCheckbox = (e, item) => {
    if (e.target.checked) {
      let arr = this.state.cryptoCheckedBoxes;
      arr.push(item.id);
      this.setState = { cryptoCheckedBoxes: arr };
    } else {
      let items = this.state.cryptoCheckedBoxes.splice(
        this.state.cryptoCheckedBoxes.indexOf(item.id),
        1
      );
      this.setState = {
        cryptoCheckedBoxes: items,
      };
    }
    //console.log(this.state.cryptoCheckedBoxes);
  };

  deleteRecordMgs(record) {
    confirmAlert({
      title: "Confirm to submit",
      message: "Really want to delete this crypto currency?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteRecord(record),
        },
        {
          label: "No",
        },
      ],
    });
  }
  deleteRecord(record) {
    axios
      .post(baseUrl + "/api/crypto-delete", { id: record.id })
      .then((res) => {
        if (res.status === 200) {
          toast(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .catch();
    this.getData();
  }

  pageChange(pageData) {
    console.log("OnPageChange", pageData);
  }

  render() {
    return (
      <div>
        <Navbar />
        <div className="d-flex" id="wrapper">
          <Sidebar />
          <RefferalManagerPlan />
          <RefferalManagerShare />
          <div id="page-content-wrapper">
            <div className="container-fluid">
              <button className="btn btn-link mb-3" id="menu-toggle">
                <FontAwesomeIcon icon={faList} />
              </button>
              {/* <button className="btn btn-outline-primary float-right mb-3 mr-2" data-toggle="modal" data-target="#add-user-modal"><FontAwesomeIcon icon={faPlus}/>Add</button> */}

              <div className="section-heading">
                <div className="container">
                  <div className="row align-items-center">
                    <div className="col-md-4 col-12">
                      <div className="heading-outer">
                        <h4 className="mt-0 man_hadding mb-0">Reffer</h4>
                      </div>
                    </div>
                    <div className="col-md-8 col-12">
                      <div className="plan-fee-btn d-flex flex-wrap justify-content-between text-right">
                        <a
                          href="javascript:void(0)"
                          className="btn btn-primary"
                          data-toggle="modal"
                          data-target="#refer-modal-plan"
                        >
                          Plan
                        </a>
                        <a
                          className="btn btn-primary"
                          data-toggle="modal"
                          data-target="#refer-modal-share"
                        >
                          Sharefee
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="reffer-main-outer">
                <div className="collection-outer">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-6 col-12">
                        <div className="collection-inner">
                          <h5>5000 INR</h5>
                          <h6>Total Buy Collection</h6>
                        </div>
                      </div>
                      <div className="col-md-6 col-12">
                        <div className="collection-inner">
                          <h5>5000 INR</h5>
                          <h6>Total Sell Collection</h6>
                        </div>
                      </div>
                      <div className="col-md-4 col-12">
                        <div className="collection-inner">
                          <h5>5000</h5>
                          <h6>Admin Collection</h6>
                        </div>
                      </div>
                      <div className="col-md-4 col-12">
                        <div className="collection-inner">
                          <h5>2500</h5>
                          <h6>Sub Admin Collection</h6>
                        </div>
                      </div>
                      <div className="col-md-4 col-12">
                        <div className="collection-inner">
                          <h5>2500</h5>
                          <h6>Upline</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="plans-outer">
                  <div className="container">
                    <div className="heading-outer">
                      <h5>Plans</h5>
                    </div>
                    <div className="plan-main-inner">
                      <div className="row">
                        <div className="col-md-3 col-sm-6 col-12">
                          <div className="plan-inner">
                            <h5>
                              {this.state.monthly == null
                                ? 0
                                : this.state.monthly}
                            </h5>
                            <h6>Monthly</h6>
                          </div>
                        </div>
                        <div className="col-md-3 col-sm-6 col-12">
                          <div className="plan-inner">
                            <h5>
                              {this.state.quartly == null
                                ? 0
                                : this.state.quartly}
                            </h5>
                            <h6>Quaterly</h6>
                          </div>
                        </div>
                        <div className="col-md-3 col-sm-6 col-12">
                          <div className="plan-inner">
                            <h5>
                              {this.state.half_yearly == null
                                ? 0
                                : this.state.half_yearly}
                            </h5>
                            <h6>Half Yearly</h6>
                          </div>
                        </div>
                        <div className="col-md-3 col-sm-6 col-12">
                          <div className="plan-inner">
                            <h5>
                              {this.state.yearly == null
                                ? 0
                                : this.state.yearly}
                            </h5>
                            <h6>Yearly</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ToastContainer />
        </div>
      </div>
    );
  }
}

RefralManager.propTypes = {
  auth: PropTypes.object.isRequired,
  cryptodata: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  cryptodata: state.cryptodata,
  records: state.records,
});
export default connect(mapStateToProps)(RefralManager);
